import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Koctech Klima - Doğanın Dengesi, Evinizin Konforu",
  description = "Koctech Klima - Doğanın Dengesi, Evinizin Konforu. Ankara'nin guvenilir iklimlendirme uzmani. Klima satis, montaj, bakim ve VRF sistemleri. 20+ yillik deneyim, 7/24 teknik destek.",
  image = "https://koctech-iklimlendirme.com/og-image.jpg",
  url = "https://koctech-iklimlendirme.com",
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content="klima, iklimlendirme, VRF sistemleri, klima montaj, klima bakim, Ankara klima, split klima, ticari klima, klima servisi" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Koctech İklimlendirme" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
      
      {/* Language */}
      <meta httpEquiv="content-language" content="tr" />
      
      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      
      {/* Theme Color */}
      <meta name="theme-color" content="#14b8a6" />
    </Helmet>
  );
};

export default SEO;
